module.exports = __webpack_public_path__ + "img/Jump Casting48.6af506a1.jpg";